import React, { useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Card,
  message,
  Spin,
  Select,
  Divider,
  Row,
  Col,
} from "antd";

// ค่าคำนำหน้าเบื้องต้น
const TITLE_OPTIONS = [
  { label: "นาย", value: "นาย" },
  { label: "นาง", value: "นาง" },
  { label: "นางสาว", value: "นางสาว" },
];

const AddCustomerRelation = ({ open, close, data, funcDataBack }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    close?.(false);
  };

  const onFinish = (values) => {
    const checkCuscode = data.some((item) => values.CUSCOD === item.CUSCOD);
    if (checkCuscode) {
      message.error("เลขบัตรประชาชนซ้ำกันในสัญญา !");
      return;
    }

    try {
      // ประกอบ payload ที่ต้องการส่งกลับ
      const payload = {
        invRoundId: data[0]?.invRoundId ?? 0,
        loanId: data[0]?.loanId ?? 0,
        contno: data[0]?.contno,
        assetOnlineId: 0,
        invId: data[0]?.invId ?? 0,
        customerId: 0, // สร้างคนใหม่ -> ยังไม่มี customerId
        investigation: false,
        CUSCOD: values.CUSCOD?.trim() || "",
        SNAM: values.SNAM || "",
        NAME1: values.NAME1 || "",
        NAME2: values.NAME2 || "",
        garno: 0,
        relation: values.relationShip || "",
        relationCustomerId: values.referencePerson, // ต้องมี และต้องมาจากที่ customerId !== 0
        asset: [],
        money: {
          moneyOnlineId: 0,
          assetOnlineId: 0,
          tr14: 0,
          familyRegistration: 0,
          operationFee: 0,
          spouseFee: 0,
          additionalFee: 0,
          total: 0,
          payStatus: null,
        },
      };

      funcDataBack?.(payload);
      form.resetFields();
      close?.(false);
    } catch (err) {
      console.error(err);
      message.error("ไม่สามารถบันทึกได้");
    }
  };

  const onFinishFailed = () => {
    message.error("กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน");
  };

  const referenceOptions = data
    .filter((item) => item.customerId !== 0) // เอาเฉพาะคนที่มี customerId จริง
    .map((item) => ({
      label: `${item.SNAM}${item.NAME1} ${item.NAME2 || ""}`,
      value: item.customerId,
    }));

  return (
    <Modal
      title={"เพิ่มข้อมูลบุคคล ➕👤"}
      open={open}
      keyboard={true}
      maskClosable={false}
      onCancel={handleCancel}
      width={820}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="Loading...">
        <Card style={{ marginBottom: 10 }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            requiredMark="optional"
          >
            <Divider orientation="left" style={{ marginTop: 0 }}>
              ข้อมูลบุคคล
            </Divider>

            <Row gutter={12}>
              <Col xs={24} md={6}>
                <Form.Item
                  label="คำนำหน้า"
                  name="SNAM"
                  rules={[{ required: true, message: "กรุณาเลือกคำนำหน้า" }]}
                >
                  <Select
                    placeholder="เลือกคำนำหน้า"
                    options={TITLE_OPTIONS}
                    showSearch
                    optionFilterProp="label"
                    size="large"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={9}>
                <Form.Item
                  label="ชื่อ"
                  name="NAME1"
                  rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
                >
                  <Input placeholder="เช่น สมชาย" />
                </Form.Item>
              </Col>

              <Col xs={24} md={9}>
                <Form.Item
                  label="นามสกุล"
                  name="NAME2"
                  rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
                >
                  <Input placeholder="กรอกนามสกุล" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label="เลขบัตรประชาชน"
                  name="CUSCOD"
                  rules={[
                    { required: true, message: "กรุณากรอกเลขบัตร" },
                    {
                      pattern: /^[0-9]{13}$/,
                      message: "กรอกเฉพาะตัวเลข 13 หลัก",
                    },
                  ]}
                >
                  <Input placeholder="ตัวเลขเท่านั้น" maxLength={13} />
                </Form.Item>
              </Col>
            </Row>

            <Divider orientation="left">ความสัมพันธ์</Divider>

            <Row gutter={12}>
              <Col xs={24} md={12}>
                <Form.Item
                  label="บุคคลอ้างอิง"
                  name="referencePerson"
                  rules={[
                    { required: true, message: "กรุณาเลือกบุคคลอ้างอิง" },
                  ]}
                >
                  <Select
                    size="large"
                    placeholder={
                      referenceOptions.length
                        ? "เลือกบุคคลอ้างอิง"
                        : "ไม่มีบุคคลอ้างอิงที่ใช้งานได้"
                    }
                    options={referenceOptions}
                    showSearch
                    optionFilterProp="label"
                    disabled={!referenceOptions.length}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label="ความเกี่ยวข้อง"
                  name="relationShip"
                  rules={[
                    { required: true, message: "กรุณาระบุความเกี่ยวข้อง" },
                  ]}
                >
                  <Input placeholder="เช่น บุตร, คู่สมรส, พี่ชาย, เพื่อน, ไม่ทราบ, อื่นๆ" />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="center">
              <Button onClick={handleCancel} style={{ marginRight: 10 }}>
                ยกเลิก
              </Button>
              <Button type="primary" htmlType="submit">
                บันทึก
              </Button>
            </Row>
          </Form>
        </Card>
      </Spin>
    </Modal>
  );
};

export default AddCustomerRelation;
